<template>
  <div class="body0">
    <img class="head_img" src="@/assets/img/circleV2/home.png" alt="" />
    <div class="body">
      <div class="body1">
        <img
          class="risk_title"
          src="@/assets/img/circleV2/risk_title.png"
          alt=""
        />
        <div class="body1_text overflow_y">
          <p class="fb">尊敬的V策财经会员：</p>
          <p>
            首先，请您知晓投资有风险。当您进行任何投资时，可能获得投资收益，但同时也面临着投资风险。
          </p>
          <p>
            其次，我司作为一家专注于K线技术交流、学习平台，会严格审核入驻方身份，且严查入驻方违规行为，但我司不对入驻方的任何行为做任何履约或担保。同时，我司更重视对各位会员的风险指导，为了更好的保护您的权利和义务，请认真详细阅读以下风险提醒：
          </p>
          <p>
            1.任何投资在带来投资收益的同时，都伴随着风险。投资有风险、入市需谨慎，量力而行；
          </p>
          <p>
            2.任何“保证收益、共担风险”的承诺都应被高度重视并理性审视其存在合理性，切勿相信天上会掉馅饼；
          </p>
          <p>
            3.在进行任何投资时，本金安全是首位。超高收益率里投资行为很可能是“本金的陷阱”；
          </p>
          <p>
            4.受金融监管政策以及理财市场相关法规政策影响，理财产品的投资、偿还等可能不能正常进行，这将导致理财产品收益降低甚至理财产品本金损失；
          </p>
          <p>
            5.在进行投资理财时，要遵守国家相关法律法规，高度重视金融安全、反洗钱法等；
          </p>
          <p>
            6.专业投资，如进行证券、期货、基金投资时，请务必选择正规金融机构，认真核实机构的资质；
          </p>
          <p>
            本提示无法揭示从投资理财的所有风险和全部情形。您在进行投资之前，应当全面了解相关法律法规、行业规定及业务规则，全面评估自身的经济实力、产品认知能力、风险控制能力、生理及心理承受能力等，审慎决定是否参与金融产品的投资。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      // headImg: ''
    };
  },
  mounted() {
    // this.getImage()
  },
  methods: {
    // 获取聊天框顶部图片
    // async getImage () {
    //   const res = await request.post('/api/index/bannerList', {
    //     type: 'pc_circle'
    //   })
    //   this.headImg = res.data[0].image
    // }
  },
};
</script>

<style scoped>
.body0 {
  position: relative;
  width: 100%;
  height: 100%;
}

.head_img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
}

.body {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 148px 30px 30px;
  box-sizing: border-box;
}

.body1 {
  width: 100%;
  height: 100%;
  padding: 30px 50px 50px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.risk_title {
  height: 45px;
  display: block;
}

.body1_text {
  position: relative;
  left: 0;
  width: calc(100% + 100px);
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 40px;
  height: calc(100% - 45px);
  text-align: justify;
  box-sizing: border-box;
  padding: 0 50px;
}

.body1_text1 > div {
  margin-bottom: 40px;
  font-family: PingFang SC-Regular, PingFang SC;
}

.body1_text1 > div > div:first-child {
  color: #4571e7;
  font-size: 16px;
  font-weight: bold;
  position: relative;
  box-sizing: border-box;
  padding-left: 20px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.body1_text1 > div > div:first-child::before {
  content: "";
  position: absolute;
  left: 0;
  width: 9px;
  height: 9px;
  background: #567eea;
  border-radius: 50%;
  box-shadow: #cacaca 0px 0px 2px 1px;
}

.body1_text1 > div > div:last-child {
  color: #999999;
  font-size: 14px;
  box-sizing: border-box;
  padding-left: 20px;
}

.pingtaiyoushi_img {
  width: 100%;
}

.ruzhuyoushi_img {
  width: 100%;
}

.shiyongqunti_img {
  width: 75%;
}

.body1_text2 {
  text-align: center;
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 20px;
}
</style>
